import React, { Component } from 'react';

interface IProps {
    className?: string;
}

// tslint:disable max-line-length
export class Logo extends Component<IProps> {
    public render() {
        const {
            props: { className },
        } = this;
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 90 54.5"
                className={className}
            >
                <path d="M60.12 29.302v17.7777c0 1.7002-.4744 3.016-1.431 3.9518-.9558.9347-2.4218 1.401-4.377 1.401-1.9555 0-3.4225-.4663-4.378-1.401-.9558-.9357-1.432-2.2516-1.432-3.9518V0L36.2133 4.051v2.0604c5.0475.3542 6.0402.071 6.0402 6.2504v35.6886c0 1.393-.3883 2.4717-1.1718 3.2383-.7856.7655-1.9874 1.1498-3.5885 1.1498l-.3152-.001c-.079.001.3924.001.3153.001-3.6715-.028-5.3477-2.4067-7.295-5.2587l-10.089-14.4954 5.5418-5.2568c3.1983-2.986 5.1327-5.474 9.824-5.616V19.756H19.469v2.0556c2.4155.073 3.6234.7836 3.6234 2.4878 0 1.8493-2.0604 3.6936-3.1992 4.8324L4.8288 44.3168v.4462c0 6.6798 0 7.106-4.8283 7.6745V54.5h15.989v-2.0625c-4.9034-.5684-4.9034-.9947-4.9034-7.6745v-3.6236l4.6893-4.404 6.6086 9.3065c.6393 1.0667 2.2024 3.056 2.2024 4.335 0 1.7063-1.8473 2.0605-3.8366 2.0605V54.5h50.3837v-2.0625c-4.7583-.6404-4.7583-1.0657-4.7583-7.7435v-16.77c0-4.234.2362-6.3536 5.925-6.3536l-.008-.011c6.1863.047 11.312 1.467 11.453 9.0335 0 7.9906-5.3687 9.3626-11.7942 9.3626h-1.9033v1.8033h5.3447c7.275 0 14.604-2.0806 14.604-10.839.003-.108.004-.217.004-.328 0-8.7604-7.328-10.838-14.605-10.838H55.2916v1.8034c4.8283.6405 4.8283 1.0668 4.8283 7.7446" />
            </svg>
        );
    }
}
